import { render, staticRenderFns } from "./questionnaires.vue?vue&type=template&id=5b74c6d4&scoped=true&"
import script from "./questionnaires.vue?vue&type=script&lang=js&"
export * from "./questionnaires.vue?vue&type=script&lang=js&"
import style0 from "./questionnaires.vue?vue&type=style&index=0&id=5b74c6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b74c6d4",
  null
  
)

export default component.exports